import PropTypes from 'prop-types';

export default PropTypes.shape({
  adults: PropTypes.number.isRequired,
  adults12To15: PropTypes.number.isRequired,
  adults16Plus: PropTypes.number.isRequired,
  origin: PropTypes.string.isRequired,
  children: PropTypes.number.isRequired,
  children4Only: PropTypes.number.isRequired,
  children5To11: PropTypes.number.isRequired,
  infants: PropTypes.number.isRequired,
  youths: PropTypes.number.isRequired,
  seniors: PropTypes.number.isRequired,
  destination: PropTypes.string.isRequired,
  outboundDate: PropTypes.string.isRequired,
  inboundDate: PropTypes.string,
  returningOrigin: PropTypes.string,
  returningDestination: PropTypes.string
});
